'use client';

import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import React from 'react';

interface ButtonProps extends Omit<MuiButtonProps, 'variant'> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'small' | 'medium' | 'large';
}

const Button: React.FC<ButtonProps> = ({ variant = 'primary', size = 'medium', children, sx, ...props }) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return {
          backgroundColor: '#890096',
          color: '#FFFFFF',
          border: '1px solid #890096',
          borderRadius: '100px',
          '&:hover': {
            backgroundColor: '#9F26AB',
            borderColor: '#9F26AB',
          },
        };
      case 'secondary':
        return {
          backgroundColor: 'transparent',
          color: '#FFFFFF',
          border: '1px solid #890096',
          borderRadius: '100px',
          '&:hover': {
            backgroundColor: 'rgba(137, 0, 150, 0.1)',
            borderColor: '#9F26AB',
          },
        };
      case 'outline':
        return {
          backgroundColor: 'transparent',
          color: '#FFFFFF',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '100px',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            borderColor: 'rgba(255, 255, 255, 0.2)',
          },
        };
      default:
        return {};
    }
  };

  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return {
          padding: '8px 16px',
          fontSize: '12px',
          minHeight: '32px',
        };
      case 'medium':
        return {
          padding: '12px 24px',
          fontSize: '14px',
          minHeight: '40px',
        };
      case 'large':
        return {
          padding: '16px 32px',
          fontSize: '16px',
          minHeight: '48px',
        };
      default:
        return {};
    }
  };

  return (
    <MuiButton
      {...props}
      sx={{
        ...getVariantStyles(),
        ...getSizeStyles(),
        textTransform: 'none',
        fontWeight: 600,
        fontFamily: 'Poppins',
        ...sx,
      }}>
      {children}
    </MuiButton>
  );
};

export default Button;
